import styles from "./styles.module.css";

const AppAmountBoxWrapper = ({ children, className, ...rest }) => {
  return (
    <div className={`${styles.amountBoxMainWrapper} ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default AppAmountBoxWrapper;
